__turbopack_context__.v({
  "athenahub": "AboutMedicalHarbour-module__Fl3XYq__athenahub",
  "bioatlas": "AboutMedicalHarbour-module__Fl3XYq__bioatlas",
  "bioatlasvet": "AboutMedicalHarbour-module__Fl3XYq__bioatlasvet",
  "desktopOnly": "AboutMedicalHarbour-module__Fl3XYq__desktopOnly",
  "logo": "AboutMedicalHarbour-module__Fl3XYq__logo",
  "logosRow": "AboutMedicalHarbour-module__Fl3XYq__logosRow",
  "mobileOnly": "AboutMedicalHarbour-module__Fl3XYq__mobileOnly",
  "partnerLogo": "AboutMedicalHarbour-module__Fl3XYq__partnerLogo",
  "text": "AboutMedicalHarbour-module__Fl3XYq__text",
  "topRow": "AboutMedicalHarbour-module__Fl3XYq__topRow",
  "wrapper": "AboutMedicalHarbour-module__Fl3XYq__wrapper",
});
